import lazyWithReload from "./helpers/lazyWithReload";
import { ACCESS_LEVEL_ANY, ACCESS_LEVEL_GUEST, ACCESS_LEVEL_AUTH } from "./constants/accessLevels";
import {
  AUTH_CALLBACK_URL,
  CES_SCREEN_URL,
  DRIVING_LICENSE_SCREEN_URL,
  FAMILY_STATUS_SCREEN_URL,
  INCOME_TAX_SCREEN_URL,
  JOB_SCREEN_URL,
  MOVABLE_ESTATE_SCREEN_URL,
  NOTARY_SCREEN_URL,
  ORGANIZATIONS_SCREEN_URL,
  TAX_REGISTRATION_DETAILS_SCREEN_URL,
  PASSPORT_SCREEN_URL,
  NOTIFICATIONS_SCREEN_URL,
  NOTIFICATION_DETAIL_SCREEN_URL,
  NOTIFICATION_SETTINGS_SCREEN_URL,
  REAL_ESTATE_SCREEN_URL,
  REAL_ESTATE_LAND_SCREEN_URL,
  REGISTRATION_ADDRESS_SCREEN_URL,
  REQUEST_HISTORY_SCREEN_URL,
  REQUEST_HISTORY_DETAIL_SCREEN_URL,
  SCHOOL_SCREEN_URL,
  SOCIAL_STATUS_SCREEN_URL,
  DISABILITY_SCREEN_URL,
  URL_AUTH_START,
  URL_DASHBOARD,
  URL_ROOT,
  VIOLATIONS_SCREEN_URL,
  WEAPONS_SCREEN_URL,
  PENSION_SCREEN_URL,
} from "./constants/urls";

// layouts
import MainLayout from "./layouts/Main";

// screens (lazy-loaded — route-based code splitting so each page ships its own chunk)
const HomeScreen = lazyWithReload(() => import("./screens/HomeScreen"));
const NotFoundScreen = lazyWithReload(() => import("./screens/NotFoundScreen"));
const SignInCallbackPage = lazyWithReload(() => import("./screens/SigninCallbackScreen"));
const AuthStartScreen = lazyWithReload(() => import("./screens/AuthStartScreen"));
const DashboardScreen = lazyWithReload(() => import("./screens/DashboardScreen"));
const PassportScreen = lazyWithReload(() => import("./screens/PassportScreen"));
const RegistrationAddressScreen = lazyWithReload(() => import("./screens/RegistrationAddressScreen"));
const DrivingLicenseScreen = lazyWithReload(() => import("./screens/DrivingLicenseScreen"));
const MovableEstateScreen = lazyWithReload(() => import("./screens/MovableEstateScreen"));
const RealEstateScreen = lazyWithReload(() => import("./screens/RealEstateScreen"));
const OrganizationsScreen = lazyWithReload(() => import("./screens/OrganizationsScreen"));
const TaxRegistrationDetailsScreen = lazyWithReload(() => import("./screens/TaxRegistrationDetailsScreen"));
const FamilyStatusScreen = lazyWithReload(() => import("./screens/FamilyStatusScreen"));
const JobScreen = lazyWithReload(() => import("./screens/JobScreen"));
const IncomeTaxScreen = lazyWithReload(() => import("./screens/IncomeTaxScreen"));
const ViolationsScreen = lazyWithReload(() => import("./screens/ViolationsScreen"));
const WeaponsScreen = lazyWithReload(() => import("./screens/WeaponsScreen"));
const SocialStatusScreen = lazyWithReload(() => import("./screens/SocialStatusScreen"));
const CesScreen = lazyWithReload(() => import("./screens/CesScreen"));
const NotaryScreen = lazyWithReload(() => import("./screens/NotaryScreen"));
const SchoolScreen = lazyWithReload(() => import("./screens/SchoolScreen"));
const RequestsHistoryScreen = lazyWithReload(() => import("./screens/RequestsHistoryScreen"));
const RequestHistoryDetailScreen = lazyWithReload(() =>
  import("./screens/RequestsHistoryScreen/RequestHistoryDetailScreen")
);
const PensionScreen = lazyWithReload(() => import("./screens/PensionScreen"));
const NotificationsScreen = lazyWithReload(() => import("./screens/NotificationsScreen"));
const NotificationDetailScreen = lazyWithReload(() =>
  import("./screens/NotificationsScreen/NotificationDetailScreen")
);
const NotificationSettingsScreen = lazyWithReload(() =>
  import("./screens/NotificationsScreen/NotificationSettingsScreen")
);

const screens = [
  {
    accessLevel: ACCESS_LEVEL_GUEST,
    pathname: URL_ROOT,
    component: HomeScreen,
    layout: MainLayout,
  },

  {
    accessLevel: ACCESS_LEVEL_GUEST,
    pathname: AUTH_CALLBACK_URL,
    component: SignInCallbackPage,
    layout: MainLayout,
  },

  {
    accessLevel: ACCESS_LEVEL_GUEST,
    pathname: URL_AUTH_START,
    component: AuthStartScreen,
    layout: MainLayout,
  },

  {
    accessLevel: ACCESS_LEVEL_AUTH,
    pathname: URL_DASHBOARD,
    component: DashboardScreen,
    layout: MainLayout,
  },
  {
    accessLevel: ACCESS_LEVEL_AUTH,
    pathname: PASSPORT_SCREEN_URL,
    component: PassportScreen,
    layout: MainLayout,
  },
  {
    accessLevel: ACCESS_LEVEL_AUTH,
    pathname: REGISTRATION_ADDRESS_SCREEN_URL,
    component: RegistrationAddressScreen,
    layout: MainLayout,
  },
  {
    accessLevel: ACCESS_LEVEL_AUTH,
    pathname: DRIVING_LICENSE_SCREEN_URL,
    component: DrivingLicenseScreen,
    layout: MainLayout,
  },

  {
    accessLevel: ACCESS_LEVEL_AUTH,
    pathname: MOVABLE_ESTATE_SCREEN_URL,
    component: MovableEstateScreen,
    layout: MainLayout,
  },
  {
    accessLevel: ACCESS_LEVEL_AUTH,
    pathname: REAL_ESTATE_SCREEN_URL,
    component: RealEstateScreen,
    layout: MainLayout,
  },
  {
    accessLevel: ACCESS_LEVEL_AUTH,
    pathname: REAL_ESTATE_LAND_SCREEN_URL,
    component: RealEstateScreen,
    layout: MainLayout,
  },
  {
    accessLevel: ACCESS_LEVEL_AUTH,
    pathname: ORGANIZATIONS_SCREEN_URL,
    component: OrganizationsScreen,
    layout: MainLayout,
  },
  {
    accessLevel: ACCESS_LEVEL_AUTH,
    pathname: TAX_REGISTRATION_DETAILS_SCREEN_URL,
    component: TaxRegistrationDetailsScreen,
    layout: MainLayout,
  },
  {
    accessLevel: ACCESS_LEVEL_AUTH,
    pathname: FAMILY_STATUS_SCREEN_URL,
    component: FamilyStatusScreen,
    layout: MainLayout,
  },
  {
    accessLevel: ACCESS_LEVEL_AUTH,
    pathname: JOB_SCREEN_URL,
    component: JobScreen,
    layout: MainLayout,
  },
  {
    accessLevel: ACCESS_LEVEL_AUTH,
    pathname: INCOME_TAX_SCREEN_URL,
    component: IncomeTaxScreen,
    layout: MainLayout,
  },
  {
    accessLevel: ACCESS_LEVEL_AUTH,
    pathname: VIOLATIONS_SCREEN_URL,
    component: ViolationsScreen,
    layout: MainLayout,
  },
  {
    accessLevel: ACCESS_LEVEL_AUTH,
    pathname: WEAPONS_SCREEN_URL,
    component: WeaponsScreen,
    layout: MainLayout,
  },
  {
    accessLevel: ACCESS_LEVEL_AUTH,
    pathname: SOCIAL_STATUS_SCREEN_URL,
    component: SocialStatusScreen,
    layout: MainLayout,
  },
  {
    accessLevel: ACCESS_LEVEL_AUTH,
    pathname: DISABILITY_SCREEN_URL,
    component: SocialStatusScreen,
    layout: MainLayout,
  },
  {
    accessLevel: ACCESS_LEVEL_AUTH,
    pathname: CES_SCREEN_URL,
    component: CesScreen,
    layout: MainLayout,
  },
  {
    accessLevel: ACCESS_LEVEL_AUTH,
    pathname: NOTARY_SCREEN_URL,
    component: NotaryScreen,
    layout: MainLayout,
  },
  {
    accessLevel: ACCESS_LEVEL_AUTH,
    pathname: SCHOOL_SCREEN_URL,
    component: SchoolScreen,
    layout: MainLayout,
  },
  {
    accessLevel: ACCESS_LEVEL_AUTH,
    pathname: REQUEST_HISTORY_SCREEN_URL,
    component: RequestsHistoryScreen,
    layout: MainLayout,
  },
  {
    accessLevel: ACCESS_LEVEL_AUTH,
    pathname: REQUEST_HISTORY_DETAIL_SCREEN_URL,
    component: RequestHistoryDetailScreen,
    layout: MainLayout,
  },
  {
    accessLevel: ACCESS_LEVEL_AUTH,
    pathname: NOTIFICATIONS_SCREEN_URL,
    component: NotificationsScreen,
    layout: MainLayout,
  },
  {
    accessLevel: ACCESS_LEVEL_AUTH,
    pathname: NOTIFICATION_DETAIL_SCREEN_URL,
    component: NotificationDetailScreen,
    layout: MainLayout,
  },
  {
    accessLevel: ACCESS_LEVEL_AUTH,
    pathname: NOTIFICATION_SETTINGS_SCREEN_URL,
    component: NotificationSettingsScreen,
    layout: MainLayout,
  },

  {
    accessLevel: ACCESS_LEVEL_AUTH,
    pathname: PENSION_SCREEN_URL,
    component: PensionScreen,
    layout: MainLayout,
  },

  // Keep this always in end
  {
    layout: MainLayout,
    accessLevel: ACCESS_LEVEL_ANY,
    pathname: "*",
    component: NotFoundScreen,
  },
];

export default screens;
